module.exports = __webpack_public_path__ + "static/img/logo.69cd1dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 98
// module chunks = 1